import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const navItems = [
  { to: '/', label: '首页' },
  { to: '/characters', label: '人物关系' },
  { to: '/cp', label: 'CP线专题' },
  { to: '/daily', label: '师门日常' },
  { to: '/about', label: '关于我们' },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled || open
          ? 'bg-background-50/90 backdrop-blur-md shadow-sm border-b border-background-200/70'
          : 'bg-background-50/70 backdrop-blur-sm border-b border-background-200/40'
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[70px] max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="group flex items-center gap-3">
          <span className="font-seal flex h-10 w-10 md:h-11 md:w-11 items-center justify-center rounded-md bg-primary-500 text-lg text-background-50 shadow-sm">
            师
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading text-lg md:text-xl font-bold tracking-wide text-foreground-950">
              师兄啊师兄
            </span>
            <span className="text-xs tracking-[0.2em] text-foreground-500">考 据 嗑 糖 站</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:bg-primary-100/70 hover:text-primary-700'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/daily"
            className="font-seal hidden whitespace-nowrap rounded-full border border-primary-300 px-4 py-2 text-base text-primary-700 transition-colors hover:bg-primary-500 hover:text-background-50 lg:inline-flex"
          >
            去追更
          </Link>
          <button
            type="button"
            aria-label="切换导航菜单"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-200 md:hidden"
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-3-line'} text-2xl`} />
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-background-200/70 bg-background-50/95 px-4 py-3 md:hidden" aria-label="移动端导航">
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `rounded-md px-4 py-3 text-base font-medium transition-colors ${
                    isActive ? 'bg-primary-500 text-background-50' : 'text-foreground-800 hover:bg-background-200'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link to="/daily" className="font-seal mt-1 rounded-md bg-primary-500 px-4 py-3 text-center text-lg text-background-50">
              去追更
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}